import MultipleSelectionEditor from '../MultipleSelectionEditor';
import MultipleSelectionView from './MultipleSelectionView';
import React from 'react';
import { SelectionComponentProps } from '../../../models/LessonComponent';
import { useLessonContext } from '../../../models/LessonContext';

export default function MultipleSelection(props: SelectionComponentProps) {
  const { mode } = useLessonContext();

  return mode === 'edit' ? (
    <MultipleSelectionEditor component={props.component} />
  ) : (
    <MultipleSelectionView {...props} />
  );
}
